import { Button, Checkbox, Layout, Modal, Space, Typography } from 'antd'
import iconBookmarks from 'assets/svgs/bookmarks.svg'
import iconBrowser from 'assets/svgs/browser-icon.svg'
import iconNote from 'assets/svgs/note-icon.svg'
import { MAGAZINE_VIEW_LOG, STORAGE_USER } from 'configs/constant'
import { BOOKMARK, HISTORY, HOME, PRIVACY, TERM } from 'configs/path'
import { useAppSelector } from 'hooks'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { bindParams } from 'utilities/helpers'
import './sider.scss'

const SidePC: React.FC = () => {
  const { t } = useTranslation()
  const [openSetting, setOpenSetting] = useState(false)
  const [confirmReset, setConfirmReset] = useState(false)
  const [formSetting, setFormSetting] = useState({
    browsing_history: false
  })
  const { setting } = useAppSelector((s) => s.app)
  const app = useAppSelector((s) => s.app.app_id)
  const userID = JSON.parse(localStorage.getItem(STORAGE_USER) || '')

  const onChangeFormSetting = (key: string, value: any) => {
    setFormSetting({
      ...formSetting,
      [key]: value
    })
  }
  const onSaveSetting = () => {
    const viewLog = JSON.parse(localStorage.getItem(MAGAZINE_VIEW_LOG) || '[]')
    const viewLogOfOtherApp = viewLog.filter((appView:any) => Object.keys(appView)[0] !== `${app}_${userID}`)

    if (!!formSetting.browsing_history) {
      localStorage.setItem(MAGAZINE_VIEW_LOG, JSON.stringify([...viewLogOfOtherApp, {
        [`${app}_${userID}`]: true
      }]))
    } else {
      localStorage.setItem(MAGAZINE_VIEW_LOG, JSON.stringify([...viewLogOfOtherApp, {
        [`${app}_${userID}`]: false
      }]))
    }
    setOpenSetting(false)
  }

  const handleResetingSetting = () => {
    setConfirmReset(false)
    setFormSetting({
      browsing_history: false
    })
    const viewLog = JSON.parse(localStorage.getItem(MAGAZINE_VIEW_LOG) || '[]')
    const viewLogOfOtherApp = viewLog.filter((appView:any) => Object.keys(appView)[0] !== `${app}_${userID}`)
    localStorage.setItem(MAGAZINE_VIEW_LOG, JSON.stringify([...viewLogOfOtherApp, {
      [`${app}_${userID}`]: false
    }]))
  }

  useEffect(() => {
    const viewLog = JSON.parse(localStorage.getItem(MAGAZINE_VIEW_LOG) || '[]')
    const viewLogOfApp = viewLog.filter((appView:any) => Object.keys(appView)[0] === `${app}_${userID}`)
    if (!!viewLogOfApp && !!viewLogOfApp[0][`${app}_${userID}`]) {
      setFormSetting({
        browsing_history: true
      })
    } else {
      setFormSetting({
        browsing_history: false
      })
    }
  }, [openSetting])
  return (
    <Layout.Sider className="sider-container" width={'100%'}>
      <div className="sider-container__title">{setting.app_name}</div>
      <Link
        to={bindParams(HOME, {
          app: app
        })}
        className="sider-item-custom"
      >
        <div className="item-icon">
          <img src={iconNote} />
        </div>
        <span>{t('all')}</span>
      </Link>
      <Link
        to={bindParams(HISTORY, {
          app: app
        })}
        className="sider-item-custom"
      >
        <div className="item-icon">
          <img src={iconBrowser} />
        </div>
        <span>{t('history')}</span>
      </Link>
      <div
        onClick={() =>
          window.open(
            bindParams(BOOKMARK, {
              app: app
            }),
            '_self'
          )
        }
        className="sider-item-custom"
      >
        <div className="item-icon">
          <img src={iconBookmarks} />
        </div>
        <span>{t('bookmarks')}</span>
      </div>
      <div className="sider-item-custom" style={{ padding: '11px 14px' }} onClick={() => setOpenSetting(true)}>
        {t('setting')}
      </div>

      <Link
        to={bindParams(TERM, {
          app: app
        })}
        className="sider-item-custom"
        style={{ padding: '11px 14px' }}
        target="_blank"
      >
        {t('term')}
      </Link>
      <Link
        to={bindParams(PRIVACY, {
          app: app
        })}
        className="sider-item-custom"
        style={{ padding: '11px 14px' }}
        target="_blank"
      >
        {t('privacy')}
      </Link>
      <Modal
        title="閲覧設定"
        className="slide-modal-seting modal-common"
        centered
        open={openSetting}
        footer={
          <Space className="footer-modal-setting">
            <Button onClick={onSaveSetting} type="primary">
              {t('save_setting')}
            </Button>
            <Button onClick={() => setConfirmReset(true)}>{t('reset_default_status')}</Button>
          </Space>
        }
        onCancel={() => setOpenSetting(false)}
      >
        <div className="content">
          <Checkbox checked={formSetting.browsing_history} onChange={(e) => onChangeFormSetting('browsing_history', e.target.checked)}>
            {t('allow_browsing_history')}
          </Checkbox>
        </div>
      </Modal>
      <Modal
        className="modal-content-reset"
        width={400}
        centered
        title=""
        open={confirmReset}
        footer={
          <Space className="footer-modal-confirm" align="center">
            <Button type="primary" onClick={handleResetingSetting} style={{ width: 73 }}>
              OK
            </Button>
            <Button onClick={() => setConfirmReset(false)}>キャンセル</Button>
          </Space>
        }
        onCancel={() => setConfirmReset(false)}
      >
        <Typography>{t('reset_to_default')}</Typography>
      </Modal>
    </Layout.Sider>
  )
}

export default SidePC
